import { SideNav, SideNavHeader } from '@/components/layout/side-nav'

import { ProfileSidebarProps } from './profile-sidebar.types'

// Note: the side nav of a record page whose sections are routes (e.g. a unit): a summary header
// on top of the shared SideNav
export const ProfileSidebar = ({
  ariaLabel,
  badges,
  items,
  subtitle,
  title,
}: ProfileSidebarProps) => (
  <SideNav
    ariaLabel={ariaLabel ?? title}
    header={<SideNavHeader hideAvatar badges={badges} subtitle={subtitle} title={title} />}
    items={items}
  />
)
